import { Typography } from '@mui/material'

export default function Contact() {
  return (
    <>
      CONTACT
    </>
  )
}
